import React from "react";
import DaumPostcode from "react-daum-postcode";
import Dialog from "../../Dialog";

function KakaoAddress({ show = false, onHide = () => {}, onReceivePost = () => {} }) {
  const HandleComplete = async (data) => {
    onReceivePost(data);
  };

  return (
    <Dialog show={show} onHide={onHide} title='주소 검색' footer={false}>
      <DaumPostcode onComplete={HandleComplete} onClose={onHide} submitMode={true} />
    </Dialog>
  );
}

export default KakaoAddress;
